import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AllMagnetsComponent } from './home/all-magnets/all-magnets.component';

export const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'home/magnets',
    component: AllMagnetsComponent,
  },
];
